<template>
    <div class="container-grid-wizard-welcome">
        <div class="container-reviews">
            <div class="body">
                <smart-icon class="icon" icon="QuoteLEft" size="32" />
                <p class="description">
                    Smart Rooster nos resultó comprensible, lo pudimos entender
                    nosotras que somos arquitectas y a nuestra contadora también
                    le gustó. Nos parece un programa limpio. Todo está en la
                    nube y actualizado.”
                </p>
                <img
                    class="image"
                    src="data:image/jpeg;base64,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"
                    alt=""
                />
                <p class="user"><span>Katerin Cordova</span>, Administrativa</p>
            </div>
        </div>
        <div class="container-select-type">
            <div class="body">
                <b-img
                    src="/images/_/_/_/_/smartroosternew/frontend/src/assets/images/logo/logogallo2.png"
                    fluid
                    alt="Responsive image"
                ></b-img>
                <h1>¡Hola 😊, te damos la bienvenida!</h1>
                <p>
                    Elige tu actividad y ayúdanos a mejorar tu experiencia en
                    Alegra Contabilidad.
                </p>
                <div class="mt-1">
                    <div class="item-wizard-welcome d-flex align-items-center ">
                        <b-img
                            class="image"
                            src="/images/_/_/_/_/smartroosternew/frontend/src/assets/images/logo/logogallo2.png"
                            alt="Responsive image"
                        ></b-img>
                        <p class="m-0 ml-1">Tengo una empresa</p>
                    </div>
                    <div class="item-wizard-welcome d-flex align-items-center ">
                        <b-img
                            class="image"
                            src="/images/_/_/_/_/smartroosternew/frontend/src/assets/images/logo/logogallo2.png"
                            alt="Responsive image"
                        ></b-img>
                        <p class="m-0 ml-1">Tengo una empresa</p>
                    </div>
                    <div class="item-wizard-welcome d-flex align-items-center ">
                        <b-img
                            class="image"
                            src="/images/_/_/_/_/smartroosternew/frontend/src/assets/images/logo/logogallo2.png"
                            alt="Responsive image"
                        ></b-img>
                        <p class="m-0 ml-1">Tengo una empresa</p>
                    </div>
                </div>
            </div>
        </div>
        
    </div>
</template>

<script>

export default {
    
    name: "WelcomeWizard"
};
</script>

<style lang="scss" scoped>
.container-grid-wizard-welcome {
    min-height: 100vh;
    display: grid;
    grid-template-columns: 2fr 5fr;
    .container-reviews {
        background-image: url("../../../../assets/images/wizard/Component 1.png");
        height: 100%;
        background-position: center;
        background-repeat: no-repeat;
        background-size: cover;
        padding: 2rem;
        //transition: .3s all ease-in-out;
        display: flex;
        align-items: center;
        justify-content: center;
        .body {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            animation-name: example;
            animation-duration: 25s;
            animation-iteration-count: infinite;
            .icon {
                justify-self: flex-start;
                align-self: flex-start;
                color: #fff;
            }
            .description {
                color: #fff;
                font-size: 14px;
                line-height: 1.5;
                @media screen and (min-width: 600px) {
                    font-size: 16px;
                }
                @media screen and (min-width: 900px) {
                    font-size: 18px;
                }
            }
            .image {
                height: 140px;
                width: 140px;
                border-radius: 100%;
                object-fit: cover;
                margin: 1rem 0;
            }
            .user {
                color: #fff;
                span {
                    font-weight: bolder;
                }
            }
        }
    }
    .container-select-type {
        padding: 2rem;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .body {
            text-align: center;
            .item-wizard-welcome {
                cursor: pointer;
                box-shadow: 1px 2px 5px rgb(0 0 0 / 10%);
                padding: 1rem;
                border-radius: 6px;
                width: 100%;
                display: flex;
                align-items: center;
                justify-content: flex-start;
                margin-bottom: 0.8rem;
                .image {
                    height: 20px;
                    width: 20px;
                    object-fit: cover;
                    object-position: center;
                }
            }
        }
    }
}
@keyframes example {
    0% {
        transform: translateY(0);
    }
    25% {
        transform: translateY(-15%);
    }
    50% {
        //transform: translateY(0);
    }
    75% {
        transform: translateY(15%);
    }
    100% {
        transform: translateY(0);
    }
}
</style>
